<template>
  <div id="app">
<!--    <img src="./assets/logo.png">-->
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    // 解决登陆成功后重新加载当前页面方法
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.downFile {
  display: inline-block;
  font-size: 16px;
  height: 40px;
  line-height: 40px;
  padding: 0 40px;
  text-align: center;
  background-color: #a60e0a;
  border-color: #a60e0a;
  color: #FFF;
  border-radius: 4px;
  text-indent: 0;
}
.downFile:hover {
  color: #fff;
}
.downFile:active {
  color: #fff;
}
.w100{
  width: 100%;
}
.w100 p{
  width:100%;
}
.btn_down {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #DCDFE6;
  color: #fff;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: .1s;
  transition: .1s;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
  margin-left: 20px;
  background-color: rgb(166, 14, 10);
  margin-bottom: 10px;
  border: none;
}
.btn_down:hover {
  color: #fff;
}
.error_validator {
  display: inline-block;
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  transform: scale(0.8);
}
.paginationClass {
  position: relative;
  z-index: 9999999 !important;
}
.error_message {
  position: relative;
  z-index: 99999999!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue